// Attendance & working hours — API docs §10. One record per employee per day.
//
// Employees punch in and out from their app (both punches carry a GPS fix); the
// partner reads the history and corrects it. `workedMinutes` is always derived
// from the two timestamps, so fixing a punch here fixes the hours payroll is
// computed from. The day is keyed by the local date of the check-in, so a late
// shift ending after midnight stays on the day it started.
//
// Scope: a BRANCH sees its own staff, a CHAIN sees every branch and narrows
// reads with `?partner=<branchId>`.
import api from "../lib/apiClient";

// §10.1 — page, limit, date (single day, wins over the range), from, to,
// employee, partner (chain only), status.
export const listAttendance = (params = {}) =>
  api.get("/attendance", { params }).then((r) => r.data);

// §10.2 — { employee, range, summary, records }. from/to default to this month.
export const getEmployeeSheet = (employeeId, params = {}) =>
  api.get(`/attendance/employees/${employeeId}`, { params }).then((r) => r.data);

// §10.3 — the sheet payroll reads: { range, totals, byEmployee }.
// from/to default to the current month, max 366 days.
export const getAttendanceSummary = (params = {}) =>
  api.get("/attendance/summary", { params }).then((r) => r.data);

// §10.4
export const getAttendanceRecord = (id) =>
  api.get(`/attendance/${id}`).then((r) => r.data);

// §10.5 — record or correct a day. Upserts on (employee, date), so calling it
// again for the same day corrects that record rather than creating a second.
// Body needs at least one of status / checkInAt / checkOutAt / note; `date`
// defaults to today and future dates are rejected.
export const recordAttendance = (employeeId, payload) =>
  api.post(`/attendance/employees/${employeeId}`, payload).then((r) => r.data);

// §10.6 — correct an existing record by id. A corrected punch keeps the
// employee's original GPS fix; only the timestamp moves and the punch's source
// becomes PARTNER, so it is always visible the time didn't come from a device.
export const updateAttendance = (id, payload) =>
  api.patch(`/attendance/${id}`, payload).then((r) => r.data);
